<div [style.margin.px]="10" [style.overflow-y]="'auto'" class="dx-card backgroundCard absoluteFill">

  <dx-drawer
    (onInitialized)="subscribeToWindowResize()"
    (openedChange)="handleDetailSubscription()"
    [(opened)]="isDrawerOpen"
    [className]="'drawerParent alarm-detail-container'"
    [closeOnOutsideClick]="false"
    [height]="'100%'"
    [openedStateMode]="appService.isSmallScreen()? 'overlap' : 'shrink'"
    [position]="'right'"
    [revealMode]="'expand'"
    [shading]="editCreateMode"
    template="template">

    <div *dxTemplate="let data of 'template'"
         [style.background-color]="getStylizedCSSVariable('--dx-component-color-bg')"
         [style.height.%]="100" [style.width.px]="setWidthOfDrawerPx()"
         style="display: flex; flex-direction: column; overflow: hidden;">

      <div [style.width.px]="setWidthOfDrawerPx()" class="drawerTitleWrapper">

        <h2 *ngIf="!editCreateMode">{{ "ALERT.DETAIL" | translate }} {{ selectedItem?.name }}</h2>
        <h2 *ngIf="editCreateMode && !!formItem && formItem.id === undefined">{{ "ALERT.CREATE" | translate }}</h2>
        <h2 *ngIf="editCreateMode && !!formItem && formItem.id !== undefined">{{ "ALERT.UPDATE" | translate }}</h2>

        <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
          <app-alarm-time-selector
            (onTimeSettingChange)="reloadAlertEvents()"
            *ngIf="!editCreateMode"
            [(endDate)]="endDate"
            [(lastEventsNumber)]="lastEventsNumber"
            [(realTimeUnit)]="realTimeUnit"
            [(realtimeValue)]="realtimeValue"
            [(startDate)]="startDate"
            [(typeOfDateSettings)]="typeOfDateSettings">
          </app-alarm-time-selector>
          <dx-button
            (onClick)="openDuplicateAlert()"
            *ngIf="!editCreateMode" [type]="'default'" icon="copy" id="duplicateAlertButton"
            text="{{'ALERT.DUPLICATE' | translate}}">
          </dx-button>
          <dx-button
            (onClick)="openEditForm()"
            *ngIf="!editCreateMode" [type]="'default'" icon="edit" id="editDeviceButton"
            text="{{'BUTTONS.UPDATE' | translate}}">
          </dx-button>
          <dx-button
            (onClick)="deleteAlert()"
            *ngIf="!editCreateMode"
            icon="trash"
            text="{{'BUTTONS.DELETE' | translate}}"
            type="danger">
          </dx-button>
          <dx-button
            (onClick)="saveAlert(); editCreateMode = false;"
            *ngIf="editCreateMode"
            [disabled]="!formEdited || !formValid"
            icon="save"
            stylingMode="contained"
            text="{{ 'BUTTONS.SAVE' | translate }}"
            type="default">
          </dx-button>
          <dx-button
            (onClick)="undoAlertEdit();"
            *ngIf="editCreateMode"
            [type]="'normal'"
            [stylingMode]="'contained'"
            icon="revert"
            text="{{'BUTTONS.CANCEL' | translate}}">
          </dx-button>
          <dx-button (onClick)="closeDrawer();" [type]="'default'" [width]="30" icon="close"></dx-button>
        </div>

      </div>

      <dx-tab-panel
        [(selectedIndex)]="selectedTab"
        [animationEnabled]="true"
        [deferRendering]="false"
        style="height: 100%; overflow: hidden">
        <dxi-item [disabled]="editCreateMode" title="{{ 'ALERT.EVENTS' | translate }}">
          <div *dxTemplate class="flexColumn">
            <div *ngIf="!!selectedItem && !!selectedItem.alarmDetail && !!selectedItem.metricInstance "
                 class="metricContainer flexFill">

              <div class="flexColumn">
                <table class="statusInfo">
                  <tr>
                    <td><span>
                        <strong>{{ 'ALERT.ALERT_START' | translate }}
                          : </strong>{{ parseDateFromNumber(selectedItem.alarmDetail.beginDate) }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span>
                        <strong>{{ 'ALERT.ALERT_END' | translate }}
                          : </strong>{{ parseDateFromNumber(selectedItem.alarmDetail.endDate) }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><span>
                      <strong>{{ 'ALERT.LAST_VALUE' | translate }}
                        : </strong>{{ appService.getParsedMetricValue(selectedItem.metricInstance) }} {{ selectedItem.metricInstance.dataUnit }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td *ngIf="selectedItem.alarmStatus === MetricAlarmStatusEnum.ALARM_ON_RANGE_UP">
                        <span>
                        <strong>{{ 'ALERT.LIMIT' | translate }}: </strong><span
                          style="color: red;">{{ 'ALERT.UPPER' | translate }}</span>
                          {{ selectedItem.additionalInfo?.numericAlarm?.upperValue }} {{ selectedItem.metricInstance.dataUnit }}
                        </span>
                    </td>
                    <td *ngIf="selectedItem.alarmStatus === MetricAlarmStatusEnum.ALARM_ON_RANGE_DOWN">
                        <span>
                        <strong>{{ 'ALERT.LIMIT' | translate }}: </strong><span
                          style="color: red;">{{ 'ALERT.LOWER' | translate }}</span>
                          {{ selectedItem.additionalInfo?.numericAlarm?.lowerValue }} {{ selectedItem.metricInstance.dataUnit }}
                        </span>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="flexFill" style="position: relative; overflow:hidden;">
                <dx-data-grid
                  #dataGrid
                  style="min-height: 350px; position: absolute; top: 0; left: 0; right:0; bottom: 0;"
                  [columnAutoWidth]="true"
                  [dataSource]="selectedAlertEvents"
                  [showBorders]="true"
                  [showRowLines]="false"
                  [wordWrapEnabled]="true">
                  <dxo-scrolling
                    [rowRenderingMode]="'virtual'"
                    [mode]="'standard'">
                  </dxo-scrolling>
                  <dxo-pager [showPageSizeSelector]="true" [visible]="true"></dxo-pager>
                  <dxo-header-filter [visible]="true"></dxo-header-filter>
                  <dxi-column
                    caption="{{ 'ALERT.TS' | translate }}"
                    dataField="ts"
                    dataType="datetime">
                    <dxo-format
                      [formatter]="parseDateFromObject">
                    </dxo-format>
                  </dxi-column>
                  <dxi-column caption="{{ 'ALERT.ALARM_STATUS' | translate }}" dataField="alarmStatus"></dxi-column>
                  <dxi-column [allowHeaderFiltering]="false" caption="{{ 'ALERT.MESSAGE' | translate }}"
                              dataField="message"></dxi-column>
                </dx-data-grid>
              </div>


            </div>
          </div>
        </dxi-item>
        <dxi-item title="{{ 'ALERT.SETTINGS' | translate }}">
          <div *dxTemplate style="overflow: auto">
            <dx-scroll-view class="fullHeight">
              <div class="metricContainer flexFill">
                <app-alert-form
                  (saveRequest)="saveAlert()"
                  *ngIf="!!formItem"
                  [(formEdited)]="formEdited"
                  [(formValid)]="formValid"
                  [(loadingData)]="loadingData"
                  [(selectedItem)]="formItem"
                  [editEnabled]="editCreateMode"
                  [partitionId]="partitionId">
                </app-alert-form>
              </div>
            </dx-scroll-view>
          </div>
        </dxi-item>
      </dx-tab-panel>
    </div>

    <div class="flexColumn" style="height: 100%; width: 100%;">
      <div [ngClass]="isMobile? 'flexColumn' : 'flexRow'" class="filterHeader">

        <div class="flexFill flexRow" style="min-width:min-content; gap: 20px; flex-wrap: wrap;">

          <div class="flexRow">

            <span>{{ 'ALERT.ALERT_STATE' | translate }}</span>

            <dx-button (onClick)="filterMetrics(MetricAlarmStatusEnum.ALARM_OFF)" [elementAttr]="{class: 'ok'}" [height]="25"
                       [ngClass]="metricFilters.includes(MetricAlarmStatusEnum.ALARM_OFF) ? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'ALERT.OK' | translate }}</span>
            </dx-button>

            <dx-button (onClick)="filterMetrics(MetricAlarmStatusEnum.ALARM_ON)" [elementAttr]="{class: 'warning'}" [height]="25"
                       [ngClass]="metricFilters.includes(MetricAlarmStatusEnum.ALARM_ON) ? 'selected' : 'deselected'"
                       stylingMode="contained" type="default">
              <span>{{ 'ALERT.WARNING' | translate }}</span>
            </dx-button>

            <dx-button (onClick)="collapsedTags = !collapsedTags"
                       hint="{{ (collapsedTags? 'ALERT.FULL_ICONS' : 'ALERT.SMALL_ICONS') | translate}}"
                       stylingMode="text">
              <i *ngIf="!collapsedTags" class="vr-ic_fluent_arrow_minimize_24_regular"></i>
              <i *ngIf="collapsedTags" class="vr-ic_fluent_arrow_maximize_24_regular"></i>
            </dx-button>

          </div>
          <div class="flexFill flexRow" style="align-items: flex-start;">

            <dx-text-box
              [(value)]="searchInput"
              [width]="'100%'"
              mode="search">
            </dx-text-box>

            <dx-button
              (onClick)="loadAlertMetrics()"
              [icon]="'refresh'"
              stylingMode="text">
            </dx-button>


          </div>

        </div>

      </div>

      <dx-scroll-view style="height: 100%; width: 100%;">
        <div *ngIf="!!partitionSelection.selectedPartitionId || partitionSelection.selectedPartitionId === 0"
             class="alarmContainer fullWidth">

          <div *ngFor="let partition of partitionAlarms"
               [ngClass]="partition.id === partitionId && isDrawerOpen ? 'selected' : ''"
               class="dx-card flexRow alarmPartitionContainer" style="align-items: center;">

            <div class="flexFill flexColumn" style="gap:5px">

              <span class="alarmPartitionName unselectable">{{ partition.path }}</span>

              <div *ngIf="!!partition.metricInstanceAlarms
              && getBySearch(partition.metricInstanceAlarms).length > 0
              && getByFilters(partition.metricInstanceAlarms, metricFilters).length > 0"
                   class="alarmContainer device">

                <ng-container *ngFor="let metric of getBySearch(partition.metricInstanceAlarms)">
                  <div #alert (click)="openMetricAlarmDetail(partition, metric); $event.stopPropagation()"
                       (mouseenter)="getTooltipTargetAndText(alert, metric)"
                       *ngIf="(metric.alarmStatus !== undefined && metricFilters.includes(metric.alarmStatus)) || metric.alarmStatus === null"
                       [ngClass]="getAlarmStatusCssClass(metric)" [style.border-radius]="collapsedTags? '50%' : ''"
                       class="dx-card alarmCard device">

                    <span *ngIf="!collapsedTags" class="alarmDeviceName unselectable">{{ metric.name }}<i
                      *ngIf="metric.hasCalendar" [title]="'ALERT.FORM.SCHEDULE_CUSTOM' | translate"
                      class="material-symbols-outlined alarmScheduleIcon">schedule</i></span>

                  </div>
                </ng-container>
              </div>

            </div>

            <dx-button
              (onClick)="openCreateForm(partition.id)"
              icon="add"
              stylingMode="text">
            </dx-button>

          </div>

        </div>
      </dx-scroll-view>
    </div>

  </dx-drawer>

</div>


<dx-popup
  (onHiding)="duplicatingAlert = undefined"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [height]="220"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'ALERT.DUPLICATE_TITLE' | translate"
  [visible]="!!duplicatingAlert"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="duplicateAlert()"
      [disabled]="!duplicateAlertName"
      [height]="40"
      [stylingMode]="'contained'"
      icon="copy"
      text="{{'ALERT.DUPLICATE' | translate}}"
      type="default">
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="duplicatingAlert = undefined"
      [height]="40"
      [stylingMode]="'outlined'"
      icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}">
    </dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <dx-text-box
      [(value)]="duplicateAlertName"
      [label]="'ALERT.DUPLICATE_NAME_LABEL' | translate"
      [maxLength]="gmService.STR_DIM_BIG"
      style="width: 100%;">
    </dx-text-box>
  </div>
</dx-popup>

<dx-popover
  [(visible)]="showTooltip"
  [target]="tooltipTarget"
  [wrapperAttr]="{
    class: 'metricTooltip'
  }"
  contentTemplate="contentTemplate"
  hideEvent="mouseleave"
  position="right">
  <div *dxTemplate="let template of 'contentTemplate'">
    <span>{{ tooltipContent }}</span>
  </div>

</dx-popover>
